import { useParams, useNavigate } from "react-router-dom";
import { useAtomValue } from "jotai";
import { findWhere } from "underscore";

import useUpdateView from "../../../../api/api-hooks/views/useUpdateView";
import usePageViewTable from "../usePageViewTable";
import { Prefill } from "../../../../types/GlobalInterfaces";
import useCreateGlobal from "../../../../api/api-hooks/globals/useCreateGlobal";
import { handleSaveGlobalQC } from "../../../../utils/QuickCreateUtils";
import { tenantIDAtom } from "../../../../atoms/GlobalAtoms";
import QuickCreateMenu from "../../../Menus/QuickCreateMenu";
import { View } from "../../../../types/PageInterfaces";
import { Module } from "../../../../types/TenantInterfaces";

const quickCreateVariableIdentifiers = ["record", "user"];

interface Props {
  toggleCreateRecordsDrawer: () => void;
  toggleImportCSVDrawer: () => void;
  setSelectedPrefill: (p: Prefill) => void;
  view: View;
  brie: boolean;
  parentViewID?: string;
  record?: any;
  module: Module;
  defaultPrefill: Prefill | null;
}

const SharedQuickCreateMenu = ({
  toggleCreateRecordsDrawer,
  toggleImportCSVDrawer,
  setSelectedPrefill,
  view,
  brie = false,
  module,
  parentViewID,
  record,
  defaultPrefill,
}: Props) => {
  const tenantID = useAtomValue(tenantIDAtom);
  const { pageID }: any = useParams();
  const { updateView, viewUpdating } = useUpdateView(pageID);
  const { createGlobal } = useCreateGlobal();
  const navigate = useNavigate();

  const { createItem, updateItem, deleteItem, reorderItems } = usePageViewTable(
    {
      currentViewID: view?._id,
      updateView,
      parentViewID,
    }
  );

  return (
    <div className="d-flex align-items-center">
      <QuickCreateMenu
        record={record}
        // @ts-ignore
        variableIdentifiers={[tenantID, ...quickCreateVariableIdentifiers]}
        moduleAPIName={view?.ModuleAPIName}
        prefills={view?.Prefills}
        setSelectedPrefill={setSelectedPrefill}
        handleCreate={createItem}
        handleUpdate={updateItem}
        // @ts-ignore
        handleDelete={deleteItem}
        // @ts-ignore
        handleReorder={reorderItems}
        handleAddGlobals={(newPrefills: any, onSuccess: () => void) => {
          // @ts-ignore
          updateView({
            parentViewID,
            viewID: view?.id as string,
            payload: {
              Prefills: newPrefills,
            },
          });
          onSuccess();
        }}
        updating={viewUpdating}
        toggleCreateRecords={toggleCreateRecordsDrawer}
        toggleImportCSV={toggleImportCSVDrawer}
        defaultPrefill={defaultPrefill}
        // @ts-ignore
        savedPrefillID={view?._SelectedPrefill}
        // @ts-ignore
        onSaveAsDefault={onSaveAsDefault}
        // @ts-ignore
        onSaveAsGlobal={handleQuickCreateSaveAsGlobal}
        currentModule={module}
      />
    </div>
  );

  function onSaveAsDefault(id: string) {
    const foundPrefill = findWhere(view?.Prefills ?? [], {
      id,
    });

    if (!foundPrefill) return console.log("prefill not found");

    if (defaultPrefill && id === defaultPrefill.id) {
      // @ts-ignore
      return updateView({
        viewID: view?.id as string,
        parentViewID,
        payload: {
          _SelectedPrefill: "",
        },
      });
    }

    // @ts-ignore
    updateView({
      viewID: view?.id as string,
      parentViewID,
      payload: {
        _SelectedPrefill: id,
      },
    });
  }

  function handleQuickCreateSaveAsGlobal(quickCreate: Prefill) {
    handleSaveGlobalQC({
      quickCreate,
      navigate,
      tenantID,
      onSave: () => {
        createGlobal({
          global: quickCreate,
          globalsType: "QuickCreates",
          onSuccess: handleUpdateViewPrefills,
        });
      },
    });
  }

  function handleUpdateViewPrefills(
    newQuickCreate: Prefill,
    previousQuickCreate: Prefill
  ) {
    if (!view?.Prefills) return;

    const newPrefillsArray = view.Prefills.map((quickCreate) => {
      if (previousQuickCreate.id === quickCreate.id) {
        return { id: previousQuickCreate.id, GlobalID: newQuickCreate.id };
      } else {
        return quickCreate;
      }
    });

    // @ts-ignore
    updateView({
      parentViewID,
      viewID: view?.id,
      payload: { Prefills: newPrefillsArray },
    });
  }
};

export default SharedQuickCreateMenu;
